import { ReactComponent } from "./pick-up-location.svg";

interface Props {
  width?: string;
  height?: string;
  fill?: string;
}

const PickUpLocationIcon: React.FC<Props> = (props) => (
  <ReactComponent {...props} />
);

export default PickUpLocationIcon;
